import { SectionContainer } from "../molecules/section-container";
import { useNavigate } from "react-router-dom";
import { Button } from "../atoms/button";

export const Instructions = () => {
  const navigate = useNavigate();

  return (
    <SectionContainer title="Perle Collect - How to">
      <h2 className="font-semibold mb-6">🎧 How to Contribute Your Recordings</h2>
      <ol className="list-decimal list-inside space-y-4 text-left font-medium">
        <li>
          <strong>Pick a Text:</strong> Choose a text to read from the list.
        </li>
        <li>
          <strong>Pick a role:</strong> All text are dialogs between 2 people. Choose one of the people and only read the text that is related to that person.
        </li>
        <li>
          <strong>Record Your Clips:</strong> Original WAV recordings
          (44.1 kHz/16-bit), ~20 seconds each. No filters or edits.
        </li>
        <li>
          <strong>Add additional information:</strong> Fill a form with information about the recording.
        </li>
        <li>
          <strong>Review &amp; Submit:</strong> Double-check audio file and then click <em>Submit</em>. (No autosave—make sure everything's set.)
        </li>
      </ol>
      <div className="mt-6 mb-4">
        <Button
          type="primary"
          text="Go to task selection"
          onClick={() => navigate("/")}
        />
      </div>
    </SectionContainer>
  );
};
